import { deviceBreakpoints, deviceBreakpointsMin } from './breakpoints';

const theme = {
  colors: {
    bgBody: '#fff',
    bgColor: '#fff',
    primary: '#943FA1',
    secondary: '#ff0052',
    light: '#D1DDE5',
    text: {
      primary: '#943FA1',
      main: '#353535',
      muted: '#9791A7',
      grey: '#9791A7',
      light: '#D7D6E0',
      white: '#FFFFFF',
      error: '#ff0052',
    },
    borders: {
      main: '#D1DDE5',
      light: '#e5ebef',
      error: '#ff0052',
    },
  },
  device: deviceBreakpoints,
  deviceMin: deviceBreakpointsMin,
};

export default theme;
